import React from 'react';
import { Section, SectionTitle } from '../../../components/TwoColumnLayout';
import styled from 'styled-components';
import { InputField } from '../../../components/InputField';

interface Props {
	phoneDirectoryOwnerData: any;
	phoneDirectoryOwnerDataChangeHandler: (field: string, value: string) => void;
}

const Container = styled.div`
  padding-top: 1rem;
    input {
    width: 250px;
  }

  input[type="text"] {
    min-width: 450px;

		@media print, screen and (min-width: 600px) {
			
		}
  }

  .info{
    width: 200px;
    font-size: 1rem;
    padding-left: 1rem;
    // border: 1px solid red;
  }

  .grayInfo{
    font-size: 1rem;
    color: darkgray;
		padding-left: 1rem;
  }
`;


export const CompanyInfo: React.FC<Props> = (props: Props) => {
	return (
		<div>
			<SectionTitle>Yrityksen tiedot numeropalveluissa</SectionTitle>
			<Section>
				<Container>
					<div className="info">
						<InputField
							title={'Yrityksen nimi'}
							field={'phone-directory-company-name'}
							value={props.phoneDirectoryOwnerData.name}
							onChange={props.phoneDirectoryOwnerDataChangeHandler}
						/>
						<InputField
							title={'Y-tunnus'}
							field={'phone-directory-company-business-id'}
							value={props.phoneDirectoryOwnerData.businessId}
							onChange={props.phoneDirectoryOwnerDataChangeHandler}
						/>
					</div>
					<div className="grayInfo"> Nämä tiedot julkaistaan numeropalveluissa ja numerotiedustelun käyttöön</div>
				</Container>
			</Section>
		</div>
	);
};